import { commitSharedFields } from '../sharing/commitSharedFields';

// What each share-sheet button tells analytics (funnel_profile_shared shareMethod)
const METHOD = {
  full: 'code_full_profile',
  group: 'code_group',
  last_custom: 'code_last_custom',
  custom: 'code_custom',
};

/**
 * Commit a share-sheet choice — at the tap on the anon paths, or, for two
 * profile holders, once the server says both have tapped (E3b-2a: the sheet
 * holds the choice until then). One commit path for both (commitSharedFields).
 *
 * @param {Object} p
 * @param {{kind: string, sharedFields?: string[], isFullName?: boolean, shareKind?: Object}} p.choice
 *   `reconnect` shares nothing new: what already flows keeps flowing (rule 7)
 * @param {string} p.room - the connection's room
 * @param {Object} p.profile - your own profile
 * @param {Object} p.connectionData - the room's record (useConnectionData / context)
 * @param {Function} p.updateContactSharingStatus - context method
 * @returns {Promise<boolean>} false when there was nothing to commit
 */
export const commitHeldChoice = async ({
  choice,
  room,
  profile,
  connectionData,
  updateContactSharingStatus,
}) => {
  if (!choice || choice.kind === 'reconnect' || !room || !profile?.name) return false;
  await commitSharedFields({
    chatRoomId: room,
    sharedFields: choice.sharedFields,
    isFullName: choice.isFullName,
    profileData: profile,
    connectionData,
    updateContactSharingStatus,
    // A per-person choice, not a preference declaration
    updateGlobalDefaults: false,
    shareMethod: METHOD[choice.kind],
    shareKind: choice.shareKind,
  });
  return true;
};
